// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__ithU7","children":"layout_children__0QNeu","header":"layout_header__WIdrS","backToHome":"layout_backToHome__GHAEQ"};